/** Path-based SPA routes so the address bar and browser back/forward work. */
const PAGE_PATHS = {
  home: "/",
  rent: "/rent",
  "list-property": "/list",
  marketplace: "/marketplace",
  favorites: "/favorites",
  profile: "/profile",
  dashboard: "/dashboard",
  calculator: "/calculator",
  news: "/news",
  "how-it-works": "/how-it-works",
  "agent-dashboard": "/my-listings",
  messages: "/messages",
  admin: "/admin",
  deposit: "/deposit",
  login: "/login",
  register: "/register",
  "verify-email": "/verify-email",
  "view-listings": "/view-listings",
  "funded-properties": "/funded",
  terms: "/terms",
  "privacy-policy": "/privacy-policy",
  "sec-disclosures": "/sec-disclosures",
  "risk-factors": "/risk-factors",
  "investor-agreement": "/investor-agreement",
  "cookie-policy": "/cookie-policy",
};

const PATH_TO_PAGE = Object.fromEntries(
  Object.entries(PAGE_PATHS).map(([page, path]) => [path, page])
);

const normalizePathname = (pathname) => {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  return p;
};

const parseRouteFromLocation = (loc = window.location) => {
  const params = new URLSearchParams(loc.search);
  if (params.get("page") === "admin") return { page: "admin", propertyId: null };

  const pathname = normalizePathname(loc.pathname);
  const propertyMatch = pathname.match(/^\/property\/([^/]+)$/);
  if (propertyMatch) {
    const propertyId = decodeURIComponent(propertyMatch[1]);
    const statePage = window.history.state?.page;
    const page = statePage && PAGE_PATHS[statePage] ? statePage : "home";
    return { page, propertyId };
  }

  const page = PATH_TO_PAGE[pathname];
  if (page) return { page, propertyId: null };

  try {
    const stored = JSON.parse(localStorage.getItem("coown_page"));
    if (stored && PAGE_PATHS[stored]) return { page: stored, propertyId: null };
  } catch (_) {}

  return { page: "home", propertyId: null };
};

const buildUrlForRoute = (page, propertyId) => {
  if (propertyId != null && propertyId !== "") {
    return `/property/${encodeURIComponent(String(propertyId))}`;
  }
  return PAGE_PATHS[page] || "/";
};

const syncRouteToUrl = (page, propertyId, { replace = false } = {}) => {
  const path = buildUrlForRoute(page, propertyId);
  const url = new URL(window.location.href);
  url.pathname = path;
  url.searchParams.delete("page");
  const next = url.pathname + url.search + url.hash;
  const state = { page, propertyId: propertyId != null && propertyId !== "" ? String(propertyId) : null };
  if (replace) window.history.replaceState(state, "", next);
  else window.history.pushState(state, "", next);
};

const readInitialPage = () => parseRouteFromLocation().page;

const isAdminUrl = () =>
  normalizePathname(window.location.pathname) === "/admin" ||
  new URLSearchParams(window.location.search).get("page") === "admin";

export {
  PAGE_PATHS,
  PATH_TO_PAGE,
  normalizePathname,
  parseRouteFromLocation,
  buildUrlForRoute,
  syncRouteToUrl,
  readInitialPage,
  isAdminUrl,
};
